import React from 'react';
import { Typography } from 'antd';
import cn from 'classnames';
import styles from './index.module.scss';

const ContentTitle = ({ children, className }) => {
  return (
    <Typography.Title level={4} className={cn(styles.root, className)}>
      {children}
    </Typography.Title>
  );
};

export default ContentTitle;
